import { Component, OnInit, Input } from '@angular/core';
import { PopupShared } from '../shared/popup-shared';

@Component({
  selector: 'app-two-action-popup',
  templateUrl: './two-action-popup.component.html',
  styleUrls: ['./two-action-popup.component.scss'],
})
export class TwoActionPopupComponent implements OnInit {
  @Input() inputs: PopupTwoActionInputModel;

  constructor(private popupShared: PopupShared) {}

  ngOnInit() {
    document
      .getElementById('child')
      .addEventListener('click', (e) => e.stopPropagation());
  }

  dismiss() {
    this.popupShared.dismissPopup();
  }

  confirm() {
    this.popupShared.dismissPopup();
    if (this.inputs.type === 'remove') {
      this.popupShared.confirmRemovePopup();
    } else if (this.inputs.type === 'send') {
      this.popupShared.confirmSendPopup();
    }
  }
}

export class PopupTwoActionInputModel {
  constructor(
    public type: string,
    public description: string,
    public rightButton: string,
    public leftButton: string,
    public img?: string
  ) {}
}
